module.exports = function isArray(x) {
  return x instanceof Array;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form-templates-bootstrap/~/tcomb/lib/isArray.js
 ** module id = 76
 ** module chunks = 0
 **/